import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import "./design.css";
import Nav from "./nav";
import Footer from "./footer";
import Top from "./top";

const baseURL = process.env.REACT_APP_API_BASE_URL;

const Old_design = () => {
  const { productId } = useParams();

  const [designs1, setDesigns1] = useState([]);
  const [designs2, setDesigns2] = useState([]);
  const [designs3, setDesigns3] = useState([]);
  const [product, setProduct] = useState("");

  // Show more / less states
  

  useEffect(() => {
    document.title = "Vareprint | Design";
  }, []);

  useEffect(() => {
    axios
      .get(`${baseURL}/product/design1/${productId}`)
      .then(res => setDesigns1(res.data.designs || []))
      .catch(err => console.error(err));

    axios
      .get(`${baseURL}/product/design2/${productId}`)
      .then(res => {
        setDesigns2(res.data.designs || []);
        if (res.data.designs?.length) {
          setProduct(res.data.designs[0].pname);
        }
      })
      .catch(err => console.error(err));

    axios
      .get(`${baseURL}/product/design3/${productId}`)
      .then(res => setDesigns3(res.data.designs || []))
      .catch(err => console.error(err));
  }, [productId]);

  return (
    <>
      <Nav />
      <Top />

      {/* Breadcrumb */}
      <div className="container" style={{ padding: "0px" }}>
        <ul className="filter_ul">
          <Link to="/"><li>Home</li></Link>
          <li>&nbsp;/&nbsp;</li>
          <li>{product}</li>
        </ul>
      </div>

      <div className="container design-container">


        <div className="row mt-3">
          {designs1.map(design => (
            <div key={design.did} className="col-sm-3 design_col">
              <div className="design_div">
                <Link to={`/preview/${design.did}`}>
                  <img
                    src={`${baseURL}/images/design/${design.images}`}
                    alt={design.pname}
                    className="design_image"
                  />
                  <p className="sku_design">{design.sku_design}</p>
                  <p className="design_name">{design.dname}</p>
                </Link>
                <p className="design_ds">{design.ds1}</p>
                <p className="price_s">&#8377; {design.total}</p>
              </div>
            </div>
          ))}
    

        

  
          {designs2.map(design => (
            <div key={design.did} className="col-sm-3 design_col">
              <div className="design_div">
                {design.did == "81" ? (
                  <Link to="/notebook/5">
                    <img
                      src={`${baseURL}/images/design/${design.images}`}
                      alt={design.pname}
                      className="design_image"
                    />
                    <p className="sku_design">{design.sku_design}</p>
                    <p className="design_name">{design.dname}</p>
                  </Link>
                ) : (
                  <Link to={`/preview/${design.did}`}>
                    <img
                      src={`${baseURL}/images/design/${design.images}`}
                      alt={design.pname}
                      className="design_image"
                    />
                    <p className="sku_design">{design.sku_design}</p>
                    <p className="design_name">{design.dname}</p>
                  </Link>
                )}
                <p className="design_ds">{design.ds1}</p>
                <p className="price_s">&#8377; {design.total}</p>
              </div>
            </div>
          ))}
    

        

       
       


          {/* { designs3.map(design => (
            <div key={design.did} className="col-sm-3 design_col">
              <div className="design_div">
                <Link to={`/preview/${design.did}`}>
                  <img
                    src={`${baseURL}/images/design/${design.images}`}
                    alt={design.pname}
                    className="design_image"
                  />
                  <p className="sku_design">{design.sku_design}</p>
                  <p className="design_name">{design.dname}</p>
                </Link>
                <p className="design_ds">{design.ds1}</p>
              </div>
            </div>
          ))} */}
        </div>

      </div>

      <br />
      <Footer />
    </>
  );
};

export default Old_design;
